module.exports = __webpack_public_path__ + "assets/img/LogoSpine.png";